export default __webpack_public_path__ + "static/media/phone.7943f54a.png";